import { css, html, LitElement } from "lit";
import {property, customElement} from 'lit/decorators.js';
import { FleetAlarm } from "../../../src/models/types/voy-fleet-alarm-model.types";
import { VoyFleetAlarmModel } from "../../../src/models/voy-fleet-alarm-model";
import { AlarmType } from "../../../src/services/types/fleet-alarms-service.types";
import { voyageCursorStyles } from '../../voyage-style/src/voyage-style';

import "./voy-fleet-alarm"

@customElement("voy-fleet-alarms-list")
export class VoyFleetAlarmsList extends LitElement {
    @property({type: Array}) public alarms: FleetAlarm[] = [];
    @property({ type: Number }) public imo?: number;
    @property({ attribute: false }) public alarmNote: string = "";
    @property({attribute: false}) public maximized: boolean = false;
    @property({ type: String }) public vesselVersion?: string = undefined;

    @property({ attribute: false }) private _handleAlarmPopupShow: boolean = false;
    @property({ attribute: false }) private _alarmType: AlarmType | null = null;
    @property({ attribute: false }) private _selectedAlarmId?: number;
    
    constructor() {
        super()

        this._toggleAlarmPopup = this._toggleAlarmPopup.bind(this);
        this._handleAlarm = this._handleAlarm.bind(this);
    }

    static get styles() {
        return [
            voyageCursorStyles,
            css`
                :host {
                    display: block;
                    font-family: 'MaerskText';
                    font-size: 12px;
                    line-height: 16px;
                    margin:0;
                    padding: 0;
                }
                .button-wrapper-maximized {
                    display: flex;
                    justify-content: end;
                    margin: 16px 0;
                    position: absolute;
                    right: 20px;
                    bottom: 0px;
                }

                .button-wrapper {
                    display: flex;
                    justify-content: end;
                    margin: 16px 0;
                }
                .handle-alarm-btn {
                    background-color: #00243D;
                    padding: 12px;
                    color: white;
                    border: none;
                    outline: none;
                    border-radius: 3px;
                    margin: 16px 0 0;
                }
                .alarm-list {
                    position: relative;
                }
                voy-fleet-alarm {
                    border-bottom: 1px solid var(--neutrals-grey-05);
                    overflow-x: hidden;
                }
                voy-fleet-alarm:last-child {
                    border-bottom: none;
                }
            `
        ];
    }

    private _toggleAlarmPopup(e: CustomEvent): void {
        if(!e.detail.alarmId || !e.detail.alarmType) {
            throw new Error("failed to open handle alarm modal, missing alarmId or alarmType from event details")
        };
        this.alarmNote = e.detail.note
        this._selectedAlarmId = e.detail.alarmId;
        this._alarmType = e.detail.alarmType;
        this._handleAlarmPopupShow = !this._handleAlarmPopupShow;
    }

    private _handleAlarm = (e: CustomEvent) => {
        if (!e.detail) {
            this._handleAlarmPopupShow = false;
            return;
        }

        VoyFleetAlarmModel!.updateAlarm(this._selectedAlarmId!, e.detail.action, e.detail.selectedReason, e.detail.alarmNote);
        this._handleAlarmPopupShow = false;
    }
    
    render() {
        return html`
            <div class="alarm-list">
                ${this.alarms
                    .map((alarm, index) => {
                    return html`
                        <voy-fleet-alarm 
                            .maximized=${this.maximized}
                            .index=${index}
                            .alarm=${alarm} 
                            .imo=${this.imo}
                            .vesselVersion=${this.vesselVersion}
                            @handle-alarm=${this._toggleAlarmPopup}
                        >
                        </voy-fleet-alarm>
                    `
                })}
            </div>
            <voy-handle-alarm-popup 
                .alarmEventType=${this._alarmType} 
                ._alarmNote=${this.alarmNote}
                ?shown=${this._handleAlarmPopupShow}
                @close=${this._handleAlarm}>
            </voy-handle-alarm-popup> 
        `
    }
}
